import FileService from "../services/FileService";
import UserService from "../services/UserService";
import UserModel from "../models/UserModel";
import AuthService from "api/services/AuthService";

class UserController {
  async updateProfile(user: UserModel, name: string, photo?: File) {
    if (photo) {
      await this.uploadPhoto(user, photo);
    }

    user.name = name;
    return UserService.updateProfile(user);
  }

  async updateUserEmail(user: UserModel, newEmail: string) {
    if (user.email === newEmail) return;

    return AuthService.updateEmail(newEmail)
      .then(() => UserService.updateEmail(user, newEmail))
      .then(() => {
        user.email = newEmail;
        user.emailVerified = false;
      });
  }

  private async uploadPhoto(user: UserModel, file: File) {
    const path = `images/${user.uid + file.name}`;
    const newPath = await FileService.upload(file, path);
    if (newPath) {
      user.photoURL = newPath;
    }
  }
}

export default new UserController();
